import React from 'react'
import YoutubeEmbed from './YoutubeEmbed'

export const FeaturedGame = () => {
    return (
        <div className="featured-game">
            <h3 className="featured">Featured Game</h3>
            <span className="icon-name">
                <img src="/images/bd.png" alt="Featured game icon" className="game-icon" />
                <h5 className="game-name">Ball Drop - Free Fall</h5>
            </span>
            
            <div className="featured-media">
                
                <YoutubeEmbed embedId={"xcTu_uB6CjY"} />
                <a href="https://play.google.com/store/apps/details?id=com.BrytStudio.BallDrop" className="play-btn" rel="noopener noreferrer" target="_blank">
                    <img src="/images/google-play-badge.png" alt="google play badge" className="googleplay-icon"/>
                </a>
            </div>
            
        </div>
    )
}
